import { useState } from "react";
import { Bell, BellRing, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i;

export const StockAlertButton = ({ productId }) => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const subscribe = async (mail) => {
    setBusy(true);
    try {
      const { data } = await api.post("/stock-alerts", { product_id: productId, email: mail });
      setDone(true);
      setOpen(false);
      toast.success(`Ti avviseremo a ${data.email} quando torna disponibile`);
    } catch (e) {
      toast.error(errMsg(e, "Iscrizione all'avviso non riuscita"));
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div data-testid="stock-alert-done" className="flex flex-1 items-center justify-center gap-2 rounded-full border-2 border-emerald-600 bg-emerald-50 px-4 py-3 text-sm font-bold text-emerald-700">
        <BellRing className="h-5 w-5" /> Avviso attivo
      </div>
    );
  }
  return (
    <>
      <button data-testid="stock-alert-button" className="btn-mc flex-1 !py-3" disabled={busy} onClick={() => (user ? subscribe() : setOpen(true))}>
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Bell className="h-5 w-5" />} Avvisami quando torna disponibile
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="stock-alert-dialog" className="max-w-sm">
          <DialogHeader>
            <DialogTitle className="font-display font-extrabold">Avvisami quando torna</DialogTitle>
            <DialogDescription>Ti scriviamo una sola mail appena l'articolo è di nuovo disponibile.</DialogDescription>
          </DialogHeader>
          <Input data-testid="stock-alert-email-input" type="email" inputMode="email" autoComplete="email" placeholder="La tua email"
            value={email} onChange={(e) => setEmail(e.target.value)} className="h-11" />
          <button data-testid="stock-alert-submit" className="btn-mc" disabled={busy}
            onClick={() => (EMAIL_RE.test(email.trim()) ? subscribe(email.trim()) : toast.error("Inserisci un'email valida"))}>
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Avvisami
          </button>
        </DialogContent>
      </Dialog>
    </>
  );
};
